export default __webpack_public_path__ + "static/media/LOGOBORDEBLANCO.f1b3d252.png";